import React from "react";
import { connect } from "react-redux";
import { Modal, Button, Icon } from "semantic-ui-react";
import PreciosForm from "./modalAsignacion/PreciosForm";
import { reduxForm } from "redux-form";
import { escuelasOps } from "../../../../ducks/escuelas";

class ModalAsignacion extends React.Component {
  componentDidMount() {
    this.props.obtenerOpcionesEscuelas();
  }

  componentWillUnmount() {
    this.props.detachOpcionesEscuelas();
    this.props.limpiarOpcionesEscuelas();
  }

  handleCancelModal = () => {
    this.props.reset();
    this.props.handleCancelModal();
  };

  render() {
    const { handleSubmit, reset } = this.props;

    return (
      <Modal open={this.props.open} size="fullscreen">
        <Modal.Header>Opciones Escuela</Modal.Header>
        <Modal.Content scrolling>
          <Modal.Description>
            <PreciosForm
              sinComedor={this.props.escuelasSinComedor}
              conComedor={this.props.escuelasConComedor}
            />
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={this.handleCancelModal} color="red">
            Cancelar <Icon name="cancel" />
          </Button>
          <Button
            color="green"
            onClick={handleSubmit(values => {
              this.props.handleAcceptModal(values);
              reset();
            })}
          >
            Guardar <Icon name="right chevron" />
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  escuelasSinComedor: state.escuelas.escuelasSinComedor,
  escuelasConComedor: state.escuelas.escuelasConComedor
});

const mapDispatchToProps = {
  obtenerOpcionesEscuelas: escuelasOps.obtenerOpcionesEscuelas,
  detachOpcionesEscuelas: escuelasOps.detachOpcionesEscuelas,
  limpiarOpcionesEscuelas: escuelasOps.limpiarOpcionesEscuelas
};

ModalAsignacion = connect(mapStateToProps, mapDispatchToProps)(ModalAsignacion);

export default reduxForm({ form: "FormOpcionesEscuela" })(ModalAsignacion);



// WEBPACK FOOTER //
// ./src/pages/escuelas/buscadores/colegios/ModalAsignacion.jsx